<template>
<b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h4 class="float-right"><b>Paso 2/3</b></h4><br/><br/>
                <div class="alert-icon">
                  <i class="fa fa-check-circle-o text-success"></i>
                </div>
                <h3 class="text-center">
                  ¡Hecho!
                  <br />
                  <small
                    class="text-muted"
                  >Se ha enviado un email a su casilla de correo {{emailagente}} con las instrucciones para generar su contraseña.</small>
                </h3>
                <hr>
                <b-row class="justify-content-center">
                  <b-button variant="primary" class="px-4 btn-action mx-auto" @click="goToLogin()">Iniciar Sesion</b-button>                  
                  <b-button class="px-4 btn-action mx-auto" @click="emailVisible = true">Cambiar Email</b-button>                  
                </b-row>
                <hr>
                <b-row v-if="emailVisible">
                  <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-envelope"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="E-Mail"
                    autocomplete="off"
                    v-model="myPayload.email"                 
                  />
                  <b-input-group-prepend>
                    <b-button @click="changeEmail()">
                      Enviar
                    </b-button>
                  </b-input-group-prepend>  
                </b-input-group>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>      
</template>

<script>
export default {
    props:{
        emailagente : '',
        payload: {

        },
    },
    data() {
        return {
            myPayload: this.payload,
            emailVisible: false,
        }        
    },
    methods:{
        goToLogin(){
            this.$router.push('/login');
        },
        changeEmail(){
            //console.log(JSON.stringify(this.myPayload));            
            this.$api.post('auth/changeemail', this.myPayload)
                     .then(r => {
                         if (r.data.status_code == 200){
                            this.emailVisible = false;
                            this.$toast.success('Solicitud Enviada. Aguarde respuesta en '+this.myPayload.email, 'Exito');
                         }
                      });
        },
    }
}
</script>
